export default __webpack_public_path__ + "static/media/bg-1.bbda48a2.jpg";